import React from 'react';

import { Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';

const CancelFormDialog = ({ open, onClose, setIsOpenCancelModal }) => {
  const handleClose = () => {
    setIsOpenCancelModal(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      PaperProps={{ style: { width: '600px' } }}
    >
      <div style={{ padding: 32, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <DialogTitle style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <h3 style={{ fontWeight: '600', margin: 0, fontSize: '26px' }}>
              Sure you want to cancel this entry?
            </h3>
          </div>
        </DialogTitle>

        <p style={{ fontWeight: '400', fontSize: '18px', color: '#4A5568' }}>
          Note that once you close this form, all progress will be lost.
        </p>

        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
            style={{ textTransform: 'none' }}
          >
            Back To Entry
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
            style={{ textTransform: 'none' }}
          >
            Cancel Entry
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default CancelFormDialog;
